



















































































































import { Component, Vue } from 'vue-property-decorator';
import { mapState } from 'vuex';
import { METHODS, SERVICE_PAYMENT_STATUSES } from '@/constants/payment';

@Component({
  computed: {
    ...mapState('Auth', {
      activeBusiness: 'activeBusiness',
    }),
    ...mapState('ServiceOrder', {
      activeServiceOrder: 'activeServiceOrder',
    }),
    ...mapState('ServicePayment', {
      activeServicePayment: 'activeServicePayment',
    }),
  },
})
export default class ServiceOrderCreateOrderReviewTable extends Vue {
  paymentMethods = METHODS;
  paymentStatuses = SERVICE_PAYMENT_STATUSES;
  activeBusiness!: Model;
  activeServiceOrder!: Model;
  activeServicePayment!: Model;

  prepaidHeaders = [
    {
      text: 'Service Item',
      value: 'name',
    },
    {
      text: 'Requested Quantity',
      value: '_requested_quantity',
    },
    {
      text: 'Unit Price',
      value: 'unit_price',
    },
    {
      text: 'Subtotal',
      value: 'unit_price',
    },
  ];

  invoiceHeaders = [
    {
      text: 'Service Item',
      value: 'name',
    },
    {
      text: 'Top up Quantity',
      value: '_available_quantity',
    },
  ];

  discount(item) {
    const discount = 100 - Math.floor(item._discount_rate * 100);
    return discount + '% off';
  }

  get isSettled() {
    return (
      [
        this.paymentStatuses.STATUS_UNPAID.key,
        this.paymentStatuses.STATUS_PAID.key,
        this.paymentStatuses.STATUS_OVERDUE.key,
      ].includes(this.activeServicePayment.status) ||
      this.activeServicePayment.method == this.paymentMethods.PREPAID.key
    );
  }

  getUnitPriceByCountry(serviceItem) {
    return (
      serviceItem.unit_price[this.activeBusiness?.country || 'AU'] ||
      serviceItem.unit_price['AU']
    );
  }
}
